import { useSelector } from 'react-redux';

import { FeatureFlag, FeatureFlagsMap } from 'inquiry/lib/interfaces/feature-flags';
import { RootState } from 'verify/redux/store';

/**
 * @name `useInquiryFeatureFlag`
 *
 * A hook that returns if the passed feature flag is on.
 * This hook should rarely be used alone. Prefer to use the FeatureFlagged
 * component instead.
 *
 */
const useInquiryFeatureFlag = (featureFlag: FeatureFlag): boolean => {
  const featureFlagsMap = useSelector<RootState, FeatureFlagsMap>(
    (state) => state.inquiry.featureFlags,
  );

  return !!featureFlagsMap?.[featureFlag];
};

export default useInquiryFeatureFlag;
